<template>
    <modal-dialog
        ref="modal"
        label="Succesvol gegenereerd 🎉"
        description="Je gloednieuwe marketing flow is met succes gecreëerd"
        hide-close
    >
        <div class="flow-created-modal">
            <div class="flow-created-modal__header">
                <span>Succesvol gegenereerd 🎉</span>
            </div>

            <div class="flow-created-modal__content">
                <p>Je gloednieuwe marketing flow is met succes gecreëerd en staat klaar om gelanceerd te worden! Alles is voorbereid: de e-mails zijn samengesteld, de ondersteunende landingspagina's (indien nodig) zijn ontwikkeld, en jouw unieke huisstijl is toegepast op alle elementen.</p>
                <p><strong>Nu sta je voor een keuze</strong>: activeer de flow direct of neem even de tijd om alle stappen en content door te nemen. Dit geeft je de kans om te zien hoe alles in zijn werk gaat en wat we precies voor jou hebben opgezet. Daarnaast kun je de teksten van de e-mails en pagina's nog naar wens aanpassen.</p>
                <p>Is het niet geweldig hoe eenvoudig dit proces is!</p>
            </div>
        </div>

        <template #footer>
            <flex-container
                align-items="center"
                justify-content="flex-end"
                padding="md"
            >
                <button-text @click="onClickView">
                    Bekijk flow
                </button-text>

                <button-block @click="onClickActivate">
                    Activeer direct
                </button-block>
            </flex-container>
        </template>
    </modal-dialog>
</template>

<script setup lang="ts">
    import { ModalDialog, type ExposedOverlay } from '@keyvue/one-ui';
    import { onMounted, ref } from 'vue';
    import { ActivateFlowCommand } from '@keyvue/one-api-client';
    import { useRouter } from 'vue-router';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import useNotify from '@/services/keyvue-ui/composables/useNotify';

    interface Props {
        flowId: string | null
    }

    const router = useRouter();
    const modal = ref<ExposedOverlay>();
    const props = defineProps<Props>();
    const { client } = useClient();
    const { notifySaved, notifyError } = useNotify();

    function navigateToFlowEditView() {
        router.push({
            name: 'edit-flow',
            params: {
                flowId: props.flowId,
            },
        });
    }

    function onClickView() {
        modal.value?.closeOverlay();
        navigateToFlowEditView();
    }

    async function onClickActivate() {
        if (!props.flowId) {
            return;
        }

        try {
            const command = new ActivateFlowCommand(props.flowId);
            await client.dispatch(command);
            notifySaved('De flow is geactiveerd', '');
            modal.value?.closeOverlay();
            navigateToFlowEditView();

            // @todo dit kan netter
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } catch (error) {
            notifyError(error);
        }
    }

    onMounted(() => modal.value?.openOverlay());
</script>

<style scoped lang="scss">
.flow-created-modal {
    &__header {
        font-weight: bold;
        font-size: size(md);
        display: flex;
        justify-content: space-between;
        margin-bottom: size(md);
    }

    &__content {
        ::v-deep(p:not(:last-child)) {
            margin-bottom: 1rem;
        }
    }
}
</style>
